export default {
  orders: {
    title: ['ORDERS'],
    description: ['ご注文情報の確認'],
    none: ['ご注文はありません'],
    playerRegistration: ['プレイヤー登録']
  }
};
